/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { Route, Routes, Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dropdown, Menu, notification } from 'antd';
import './App.less';
import routers from './router/router';
import { RootState } from './redux';
import {
    MenuSvgComponent,
    QuerySvgComponent,
    ProfileSvgComponent,
    TemplateUploadSvgComponent,
    UserManagementSvgComponent,
    AnalysesSvgComponent,
    ExpandButtonSvgComponent,
    MenuNewMessageIcon,
    SoilProfileWarningIcon,
    SoilProfileAddProfileSuccess,
    WeatherStationSvg,
    AgriAlertSvg,
    AgrialertTemplateSvg,
    AgrialertUserManagementSvg,
    SelfServicePortalSvgComponent,
    SoilAnalysisSvgComponent,
    WeatherStationHistorySvg,
    WeatherArrowDropDown
} from './resource/IconComponentSets';
import CEhub from './resource/icon-png/CEhub.png';
import { menuSelectedColor, menuUnselectedColor } from './router/colors';
import { getMenu, getPoliticalAreaList, soilSelfGetService, userManagementGetCurrentUserInfo } from './util/Request';
import {agriAlertGetCurrentUser} from './util/Request/agrialert';
import IF from './components/IF';
import SoilOperationPanel from './components/SoilOperationPanel';
import { select } from './redux/reducer/menuSelected';
import { useLocation } from 'react-router-dom';
import HelpCarousel from './components/HelpCarousel';
import { updateUserInfo } from './redux/reducer/soilUser';
import Loading from './components/Loading';
import { updateCurrentSys } from './redux/reducer/common';
import SoilMenuItem from './components/SoilMenuItem';
import { updateIsCelsius, updateSpeedUnit } from './redux/reducer/weatherStation';
import {TEST_TITLE} from '@/util/Request/config';
import { updateCurrentRoleId, updateCurrentUserId, updateTemplateType } from './redux/reducer/agrialertTemplate';
import { TemplateEnumType } from './util/Request/agrialert/responseType';
import localforage from 'localforage';
import HelpCarouselAgrialert from './components/HelpCarouselAgrialert';

interface ISelectedState {
    querySelected: boolean,
    soilProfileSelected: boolean,
    soilAnalysesSelected: boolean,
    templateUpdateSelected: boolean,
    referenceDataSelected: boolean,
    userManagementSelected: boolean,
    soilHistorySelected: boolean
}

interface IWeatherSelectedState {
    weatherSelected: boolean,
    weatherHistorySelected: boolean
}
interface IAgrialertSelectedState {
    templateSelected: boolean,
    userManagementSelected: boolean
}

interface IMenuItem {
    search: boolean
    soilProfiles: boolean
    template: boolean
    management: boolean
    reference: boolean
    soilAnalysis: boolean
    soilHistory: boolean
    // SECTION: weather-station part 09-22-2022
    weatherStation: boolean
    weatherStationHistory: boolean
}

enum IType {
    Query,
    SoilProfile,
    SoilAnalyses,
    TemplateUpdate,
    ReferenceData,
    UserManagement,
    SoilHistory
}

enum IWeatherType {
    WeatherStation,
    WeatherStationHistory
}
enum IAgrialertType {
    TemplateManagement,
    UserManagement
}

function App() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const currentUserId = useSelector((state: RootState) => state.agrialertTemplate.currnetUserId);
    const currentRoleId = useSelector((state: RootState) => state.agrialertTemplate.currentRoleId);
    const token = localStorage.getItem('accessToken');
    // const token = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InMxMDc2MjgxIiwiZW1haWwiOiJrYWltaW4udGFuQHN5bmdlbnRhLmNvbSIsImdpdmVuX25hbWUiOiJ0YW4ga2FpbWluIChleHQpIENOQkoiLCJuYW1laWQiOiJrYWltaW4iLCJwcmVzZW50X2pzb24iOiJ7XCJVc2VySWRcIjpcInMxMDc2MjgxXCIsXCJVc2VyRW1haWxcIjpcImthaW1pbi50YW5Ac3luZ2VudGEuY29tXCIsXCJEaXNwbGF5TmFtZVwiOlwidGFuIGthaW1pbiAoZXh0KSBDTkJKXCIsXCJVc2VyU2ltcGxpZnlOYW1lXCI6XCJLVFwiLFwiVXNlckZpcnN0TmFtZVwiOlwia2FpbWluXCJ9IiwiaWF0IjoiMTczNTE4NDE2OCIsIm5iZiI6IjE3MzUxODQxNjgiLCJleHAiOiIxNzM1MjcwNTY4IiwiaXNzIjoiUG9ydGFsQ2VodWJJc3N1ZXIiLCJhdWQiOiJDRUh1YlBvcnRhbEF1ZGllbmNlIn0.psobMWJKS46WjyBUKYaJ8KFHJ2zpdZy2V_zDG1kFSdU';
    const firstUserName = localStorage.getItem('userFirstName');

    console.log('enviroment ',process.env.BABEL_ENV);

    //when Location Path is /home or /feedback,menu should be different
    const [isShowNewMenu, setIsShowNewMenu] = useState('none');
    const [isShowSpan, setIsShowSpan] = useState('none');
    const [isShowIcon, setIsShowIcon] = useState('none');
    const [isShowBgColor, setIsShowBgColor] = useState('');
    const [isChangFontColor, setIsChangFontColor] = useState('');
    const [isChangFontWeight, setIsChangFontWeight] = useState(400);

    const [selectedState, setSelectedState] = useState<ISelectedState>({
        querySelected: true,
        soilProfileSelected: false,
        soilAnalysesSelected: false,
        templateUpdateSelected: false,
        referenceDataSelected: false,
        userManagementSelected: false,
        soilHistorySelected: false
    });

    const [weatherSelectedState, setWeatherSelectedState] = useState<IWeatherSelectedState>({
        weatherHistorySelected: false,
        weatherSelected: false
    });
    const [agrialertSelectedState, setAgriaslertSelectedState] = useState<IAgrialertSelectedState>({
        templateSelected: false,
        userManagementSelected: false
    });

    const [show, setShow] = useState(false);
    const [menu, setMenu] = useState<IMenuItem>({
        search: true,
        soilProfiles: true,
        template: true,
        reference: true,
        soilAnalysis: true,
        management: true,
        // SECTION: weather-station part 09-22-2022
        weatherStation: true,
        weatherStationHistory: true,
        // SECTION: soil history
        soilHistory: true
    });
    const [usageVisible, setUsageVisible] = useState(false);
    const [usageVisibleAlert, setUsageVisibleAlert] = useState(false);
    // used to adjust padding top value
    const [siderbarPaddingTop,setSiderbarPaddingTop] = useState(126);

    // SECTION: get store value from redux
    const currentPage = useSelector((state: RootState) => state.menuSelected);
    const showLoading = useSelector((state: RootState) => state.commonData.showLoading);
    const warningMessage = useSelector((state: RootState) => state.commonData.showWarningMessage);
    const successMessage = useSelector((state: RootState) => state.commonData.successMessage);
    const currentSys = useSelector((state:RootState) => state.commonData.currentSys);
    const underChart = useSelector((state:RootState) => state.weatherStation.chart);
    const temperatureUnit = useSelector((state: RootState) => state.weatherStation.isCelsius);
    const windSpeed = useSelector((state: RootState) => state.weatherStation.speed);
    const oauthUrl = useSelector((state: RootState) => state.weatherStation.oauthUrl);
    const firstName = useSelector((state: RootState) => state.soilUser.userFirstName);
    const treeData = useSelector((state: RootState) => state.weatherStation.treeData);

    useEffect(() => {
        // if treeData have been constructed return it
        // const areasString = localStorage.getItem('politicalAreaList');
        // if (!areasString) {
        //     requestPoliticalAreaList();
        // }

        localforage.getItem('politicalAreaList').then(value=>{
            if(value==null||value==undefined){
                getPoliticalAreaList().then(result=>{
                    localforage.setItem('politicalAreaList', JSON.stringify(result));
                });
            }
        });
        getMenu();
    }, []);

    useEffect(() => {
        if (oauthUrl && oauthUrl.length > 0) {
            const a = document.getElementById('redirect');
            a.click();
        }
    }, [oauthUrl]);

    useEffect(() => {
        if (location.hash && location.hash.length > 0 && token && token.length > 0) {
            navigate(location.pathname);
        }
    }, [token]);

    // SECTION: function area
    // const requestPoliticalAreaList = async () => {
    //     const areasString = localStorage.getItem('politicalAreaList');
    //     let areas;
    //     if (!(areasString && areasString.length > 0)) {
    //         areas = await getPoliticalAreaList();
    //         localStorage.setItem('politicalAreaList', JSON.stringify(areas));
    //     }
    // };

    const openNotification = (message: string) => {
        const args = {
            message: '',
            icon: <SoilProfileWarningIcon className='notification-icon-style' />,
            description: message,
            duration: 3,
            style: {
                width: '350px',
                innerHeight: '48px',
                paddingRight: '40px'
            }
        };
        notification.open(args);
    };

    // SECTION: function area
    const successNotification = (message: string) => {
        const args = {
            message: '',
            icon: <SoilProfileAddProfileSuccess className='notification-icon-style' />,
            description: message,
            duration: 3,
            style: {
                width: '350px',
                innerHeight: '48px',
                paddingRight: '40px'
            },
        };
        notification.open(args);
    };

    const selecteWeatherCurrentRoute = (type: IWeatherType) => {
        switch (type) {
            case IWeatherType.WeatherStation: {
                setWeatherSelectedState({
                    weatherSelected: true,
                    weatherHistorySelected: false
                });
                break;
            }
            case IWeatherType.WeatherStationHistory: {
                setWeatherSelectedState({
                    weatherSelected: false,
                    weatherHistorySelected: true
                });
            }
        }
    };
    const selecteAgrielertCurrentRoute = (type: IAgrialertType) => {
        switch (type) {
            case IAgrialertType.TemplateManagement: {
                setAgriaslertSelectedState({
                    templateSelected: true,
                    userManagementSelected: false
                });
                break;
            }
            case IAgrialertType.UserManagement: {
                setAgriaslertSelectedState({
                    templateSelected: false,
                    userManagementSelected: true
                });
            }
        }
    };

    const selecteCurrentRoute = (type: IType) => {
        console.log(type);
        switch (type) {
            case IType.Query: {
                dispatch(select({ currentSelected: 'QUERY' }));
                setSelectedState({
                    querySelected: true,
                    soilProfileSelected: false,
                    soilAnalysesSelected: false,
                    templateUpdateSelected: false,
                    referenceDataSelected: false,
                    userManagementSelected: false,
                    soilHistorySelected: false
                });
                break;
            }
            case IType.SoilProfile: {
                dispatch(select({ currentSelected: 'PROFILE' }));
                setSelectedState({
                    querySelected: false,
                    soilProfileSelected: true,
                    soilAnalysesSelected: false,
                    templateUpdateSelected: false,
                    referenceDataSelected: false,
                    userManagementSelected: false,
                    soilHistorySelected: false
                });
                break;
            }
            case IType.SoilAnalyses: {
                dispatch(select({ currentSelected: 'ANALYSES' }));
                setSelectedState({
                    querySelected: false,
                    soilProfileSelected: false,
                    soilAnalysesSelected: true,
                    templateUpdateSelected: false,
                    referenceDataSelected: false,
                    userManagementSelected: false,
                    soilHistorySelected: false
                });
                break;
            }
            case IType.TemplateUpdate: {
                dispatch(select({ currentSelected: 'TEMPLATE' }));
                setSelectedState({
                    querySelected: false,
                    soilProfileSelected: false,
                    soilAnalysesSelected: false,
                    templateUpdateSelected: true,
                    referenceDataSelected: false,
                    userManagementSelected: false,
                    soilHistorySelected: false
                });
                break;
            }
            case IType.ReferenceData: {
                dispatch(select({ currentSelected: 'REFERENCE' }));
                setSelectedState({
                    querySelected: false,
                    soilProfileSelected: false,
                    soilAnalysesSelected: false,
                    templateUpdateSelected: false,
                    referenceDataSelected: true,
                    userManagementSelected: false,
                    soilHistorySelected: false
                });
                break;
            }
            case IType.UserManagement: {
                dispatch(select({ currentSelected: 'MANAGEMENT' }));
                setSelectedState({
                    querySelected: false,
                    soilProfileSelected: false,
                    soilAnalysesSelected: false,
                    templateUpdateSelected: false,
                    referenceDataSelected: false,
                    userManagementSelected: true,
                    soilHistorySelected: false
                });
                break;
            }
            case IType.SoilHistory: {
                dispatch(select({ currentSelected: 'SOILHISTORY' }));
                setSelectedState({
                    querySelected: false,
                    soilProfileSelected: false,
                    soilAnalysesSelected: false,
                    templateUpdateSelected: false,
                    referenceDataSelected: false,
                    userManagementSelected: false,
                    soilHistorySelected: true
                });
            }
        }
    };

    const loginWithRole = async () => {
        const userInfo = await userManagementGetCurrentUserInfo();
        dispatch(updateUserInfo(userInfo));
        const menuResponse = await getMenu();
        const initialMenu = {
            search: false,
            soilProfiles: false,
            soilAnalysis: false,
            template: false,
            management: false,
            reference: false,
            weatherStation: false,
            weatherStationHistory: false,
            soilHistory: false
        };
        menuResponse.forEach(menuItem => {
            switch (menuItem.menuName) {
                case 'Search':
                    initialMenu.search = true;
                    break;
                case 'Soil Profiles':
                    initialMenu.soilProfiles = true;
                    break;
                case 'Soil Analysis':
                    initialMenu.soilAnalysis = true;
                    break;
                case 'Templates':
                    initialMenu.template = true;
                    break;
                case 'User Management':
                    initialMenu.management = true;
                    break;
                case 'Soil Profile Reference Data':
                    initialMenu.reference = true;
                    break;
                case 'My Queries':
                    initialMenu.soilHistory = true;
                    break;
            }
        });
        setMenu(initialMenu);
    };
    // const [currentRoleId, setCurrentRoleId] = useState<number>();
    const [isShowAgriAlertUser, setIsShowAgriAlertUser] = useState<boolean>();
    const agriAlertGetCurrentUserInfo=async()=>{
        const userInfo = await agriAlertGetCurrentUser('agri alert');
        dispatch(updateCurrentUserId(userInfo.data.userId));
        dispatch(updateCurrentRoleId(userInfo.data.roleId));
        // setCurrentRoleId(userInfo.data.roleId);
    };
    useEffect(()=>{
        agriAlertGetCurrentUserInfo();
    },[]);

    useEffect(()=>{
        if(currentRoleId===1)
            setIsShowAgriAlertUser(true);
        else
            setIsShowAgriAlertUser(false);
    },[currentRoleId]);
    const toggleTheMenuShow = () => {
        setShow(true);
    };

    const toggleTheMenuHide = () => {
        setShow(false);
    };

    // SECTION: useEffect area
    useEffect(() => {
        dispatch({
            type: 'common/deleteFile'
        });
    }, [location.pathname]);

    useEffect(() => {
        switch (location.pathname) {
            // Soil
            case '/':
                selecteCurrentRoute(0);
                break;
            case '/soilhub':
                selecteCurrentRoute(0);
                break;
            case '/profile':
                selecteCurrentRoute(1);
                break;
            case '/analyses':
                selecteCurrentRoute(2);
                break;
            case '/templateUpdate':
                selecteCurrentRoute(3);
                break;
            case '/RefrenceData':
                selecteCurrentRoute(4);
                break;
            case '/userManagement':
                selecteCurrentRoute(5);
                break;
            case '/soilHistory':
                selecteCurrentRoute(6);
                break;
            // Weather
            case '/weatherQuery':
                selecteWeatherCurrentRoute(0);
                break;
            case '/weatherQueryHistory':
                selecteWeatherCurrentRoute(1);
                break;
            // Agrialert
            case '/agrialert/template':
                selecteAgrielertCurrentRoute(0);
                break;
            case '/agrialert/userManagement':
                selecteAgrielertCurrentRoute(1);
                break;
        }
        if (/weatherQuery\/*/.test(location.pathname) && location.pathname !== '/weatherQueryHistory') {
            selecteWeatherCurrentRoute(0);
        }

        if (/soilhub\/*/.test(location.pathname)) {
            selecteCurrentRoute(0);
        }
    }, [location]);

    useEffect(() => {
        switch (location.pathname) {
            case '/':
            case '/home':
                dispatch(updateCurrentSys('home'));
                break;
            case '/soilhub':
            case '/profile':
            case '/analyses':
            case '/templateUpdate':
            case '/RefrenceData':
            case '/userManagement':
            case '/soilHistory':
                dispatch(updateCurrentSys('soil'));
                loginWithRole();
                break;
            case '/weatherQuery':
            case '/weatherQueryHistory':
                dispatch(updateCurrentSys('weather'));
                break;
            case '/agrialert/template':
            case '/agrialert/userManagement':
                dispatch(updateCurrentSys('agrialert'));
                break;
        }
        if (/weatherQuery\/*/.test(location.pathname)) {
            dispatch(updateCurrentSys('weather'));
        }

        if (/soilhub\/*/.test(location.pathname)) {
            dispatch(updateCurrentSys('soil'));
        }
    }, [location.pathname]);

    useEffect(() => {
        if (warningMessage && warningMessage.warningMessage && warningMessage.warningMessage.length > 0) {
            openNotification(warningMessage.warningMessage);
        }
    }, [warningMessage]);

    useEffect(() => {
        if (successMessage && successMessage.successMessage.length > 0) {
            successNotification(successMessage.successMessage);
        }
    }, [successMessage]);

    useEffect(() => {
        if (location.pathname.trim() === '/home' || location.pathname.trim() === '/') {
            //console.log('Location Path is : ', location.pathname);
            setIsShowSpan('block');
            setIsShowIcon('none');
            setIsShowBgColor('#FFFFFF');
            setIsChangFontColor('#14151C');
            setIsChangFontWeight(600);
            setIsShowNewMenu('none');
        }
        else if (location.pathname.trim() === '/feedback') {
            setIsShowSpan('block');
            setIsShowIcon('none');
            setIsShowBgColor('#19A04B');
            setIsChangFontColor('#FFFFFF');
            setIsChangFontWeight(400);
            setIsShowNewMenu('block');
        }
        else {
            setIsShowSpan('none');
            setIsShowIcon('block');
            setIsShowNewMenu('none');
        }
    });



    const temperatureItems = [
        { label: 'Celsius', key: 'C', onClick: () => dispatch(updateIsCelsius(true))}, // 菜单项务必填写 key
        { label: 'Fahrenheit ', key: 'F', onClick: () => dispatch(updateIsCelsius(false))},
    ];

    const windspeedItems = [
        { label: 'Km/h', key: 'Km/h', onClick: () => dispatch(updateSpeedUnit(0))}, // 菜单项务必填写 key
        { label: 'm/s ', key: 'm/s', onClick: () => dispatch(updateSpeedUnit(1))},
    ];

    useEffect(()=>{
        let tmpSiderbarPaddingTop = siderbarPaddingTop;
        switch(currentSys){
            case 'soil':
                tmpSiderbarPaddingTop = 80;
                break;
            case 'weather':
                tmpSiderbarPaddingTop = 70;
                break;
            case 'agrialert':
                tmpSiderbarPaddingTop = 75;
                break;
            default:
                tmpSiderbarPaddingTop = 126;
                break;
        }
        setSiderbarPaddingTop(tmpSiderbarPaddingTop);
    },[currentSys]);



    // SECTION: render part
    return token ? (
        <div id="app-component" >
            <HelpCarousel
                visible={usageVisible}
                onCancel={() => setUsageVisible(false)}
                onOk={() => setUsageVisible(false)}
            />
            <HelpCarouselAgrialert
                visible={usageVisibleAlert}
                onCancel={() => setUsageVisibleAlert(false)}
                onOk={() => setUsageVisibleAlert(false)}
            />
            <IF show={currentPage.currentSelected === 'ANALYSES' || currentPage.currentSelected === 'MANAGEMENT' ||
                currentPage.currentSelected === 'PROFILE' || currentPage.currentSelected === 'TEMPLATE'}>
                <SoilOperationPanel type={currentPage.currentSelected} />
            </IF>
            <div className="cehub-menu">
                <div style={{display:'flex'}}>
                    <Button
                        type="link"
                        className='home-button'
                    >
                        <Link to="/home"><MenuSvgComponent color={menuUnselectedColor} /></Link>
                    </Button>
                    <Link to="/home">
                        <img src={CEhub} alt="logo" draggable={false} className='logo-img' />
                    </Link>
                </div>
                <div className='unit-div'>
                    <IF show={underChart}>
                        <button>
                            <span className='unit-title-span'>Units</span>
                        </button>
                        <Dropdown overlay={<Menu items={temperatureItems} />}>
                            <a className='unit-span'>Temperature: {temperatureUnit ? '℃' : '℉'}<WeatherArrowDropDown /></a>
                        </Dropdown>
                        <Dropdown overlay={<Menu items={windspeedItems} />}>
                            <a className='unit-span'>Windspeed: {windSpeed ? 'm/s' : 'Km/h'} <WeatherArrowDropDown /></a>
                        </Dropdown>
                    </IF>
                </div>
                <div className='welcom-div'>
                    <a href='https://syngenta.sharepoint.com/sites/ce-hub'>
                        <span style={{ display: isShowSpan, fontWeight: 600, color: '#14151C' }}>Help</span>
                    </a>
                    <a href='/feedback'>
                        <span
                            style={{
                                fontWeight: isChangFontWeight,
                                display: isShowSpan,
                                backgroundColor: isShowBgColor,
                                color: isChangFontColor,
                                padding: '5px 10px',
                                borderRadius: '15px',
                                border: '1px solid #19A04B'
                            }}
                        >
                            Feedback
                        </span>
                    </a>
                    <IF show={!(currentSys === 'weather' || currentSys === 'agrialert')}>
                        <span
                            className='message-span'
                            style={{ display: isShowIcon }}
                            onClick={() => setUsageVisible(true)}
                        >
                            <MenuNewMessageIcon />
                        </span>
                    </IF>
                    <IF show={currentSys === 'agrialert'}>
                        <span
                            className='message-span'
                            style={{ display: isShowIcon }}
                            onClick={() => setUsageVisibleAlert(true)}
                        >
                            <MenuNewMessageIcon />
                        </span>
                    </IF>
                    <span className='separate-span' />
                    <span className='welcome-span'>
                        {`Hello, ${firstUserName || firstName}`}
                    </span>
                </div>
            </div>
            <div style={{ display:'none' }} className='notify-div'>
                <div className='notify'>
                    <span className='spanFontTitle'>📢 Upcoming Webinar: CE Hub Weather Data Analysis Portal! 🌦️💻</span>
                    <span className='spanFont'>Are you ready to revolutionize how you work with weather data?</span>
                    <span className='spanFont'>Join us for an exclusive webinar introducing the <a href='https://dash.arp.cloud.syngenta.org/cehubdata/homepage'>CE Hub Weather Data Analysis Portal</a>.</span>
                    <span className='spanFont'><a href='https://forms.office.com/e/HR9pLdYSyG'>Click Here</a> to add the webinar to your Outlook calendar!</span>
                </div>
            </div>
            <div className="sidebar"
                style={{paddingTop: `${siderbarPaddingTop}px`}}
            >
                {/* For soil system siderbar setting */}
                <div className="menu-div-hard-width" style={{ display: currentSys === 'soil' ? 'block' : 'none' }}>
                    <div
                        className={`menuDiv  ${show ? 'show' : 'hide'}`}
                        onMouseEnter={toggleTheMenuShow}
                        onMouseLeave={toggleTheMenuHide}
                    >
                        <ul className="nav">
                            <SoilMenuItem
                                selected={selectedState.querySelected}
                                path={'/soilhub'}
                                title='Search'
                                // onClick={() => selecteCurrentRoute(IType.Query)}
                                included={menu.search}
                            >
                                {(color: string) => <QuerySvgComponent color={color} />}
                            </SoilMenuItem>
                            <SoilMenuItem
                                selected={selectedState.soilProfileSelected}
                                path={'/profile'}
                                title='Soil Profiles'
                                // onClick={() => selecteCurrentRoute(IType.SoilProfile)}
                                included={menu.soilProfiles}
                            >
                                {(color: string) => <ProfileSvgComponent color={color} />}
                            </SoilMenuItem>
                            <SoilMenuItem
                                selected={selectedState.soilAnalysesSelected}
                                path={'/analyses'}
                                title='Soil Analysis'
                                // onClick={() => selecteCurrentRoute(IType.SoilAnalyses)}
                                included={menu.soilAnalysis}
                            >
                                {(color: string) => <AnalysesSvgComponent color={color} />}
                            </SoilMenuItem>
                            <SoilMenuItem
                                selected={selectedState.templateUpdateSelected}
                                path={'/templateUpdate'}
                                title='Templates'
                                // onClick={() => selecteCurrentRoute(IType.TemplateUpdate)}
                                included={menu.template}
                            >
                                {(color: string) => <TemplateUploadSvgComponent color={color} />}
                            </SoilMenuItem>
                            <SoilMenuItem
                                selected={selectedState.userManagementSelected}
                                path={'/userManagement'}
                                title='User Management'
                                // onClick={() => selecteCurrentRoute(IType.UserManagement)}
                                included={menu.management}
                            >
                                {(color: string) => <UserManagementSvgComponent color={color} />}
                            </SoilMenuItem>
                            {/* Soil history */}
                            <SoilMenuItem
                                selected={selectedState.soilHistorySelected}
                                path={'/soilHistory'}
                                title='My queries    '
                                // onClick={() => selecteCurrentRoute(IType.UserManagement)}
                                // included={menu.soilHistory}
                                included={true}
                            >
                                {(color: string) => <WeatherStationHistorySvg color={color} />}
                            </SoilMenuItem>
                        </ul>
                        <IF show={currentSys === 'soil'}>
                            <div className="liclass expandItem"
                                // onClick={() => selecteCurrentRoute(IType.ReferenceData)}
                            >
                                <Link to="/RefrenceData">
                                    <ExpandButtonSvgComponent
                                        classname="expandSvg"
                                        color={selectedState.referenceDataSelected ?
                                            menuSelectedColor : menuUnselectedColor} />
                                    <span
                                        className={`reference-span ${selectedState.referenceDataSelected ? 'selected-span' : 'unselected-span'}`}
                                    >
                                        Soil Profile Reference Data
                                    </span>
                                </Link>
                            </div>
                        </IF>
                    </div>
                </div>

                {/* For weather query system siderbar setting */}
                <div className="menu-div-hard-width" style={{ display: (currentSys === 'weather' ? 'block' : 'none' ) }}>
                    <ul className="nav">
                        <div
                            className={`weather-menuDiv ${show ? 'show' : 'hide'}`}
                            onMouseEnter={toggleTheMenuShow}
                            onMouseLeave={toggleTheMenuHide}
                        >
                            <SoilMenuItem
                                selected={weatherSelectedState.weatherSelected}
                                path={'/weatherQuery'}
                                title='Weather Station'
                                // onClick={() => selecteWeatherCurrentRoute(IWeatherType.WeatherStation)}
                            >
                                {(color: string) => <WeatherStationSvg color={color} />}
                            </SoilMenuItem>
                            <SoilMenuItem
                                selected={weatherSelectedState.weatherHistorySelected}
                                path={'/weatherQueryHistory'}
                                title='My queries'
                                // onClick={() => selecteWeatherCurrentRoute(IWeatherType.WeatherStationHistory)}
                            >
                                {(color: string) => <WeatherStationHistorySvg color={color} />}
                            </SoilMenuItem>
                        </div>
                    </ul>
                </div>

                {/* For feedback set new menu */}
                {/* For feedback system siderbar setting */}
                <div className="menu-div-hard-width" style={{ display: isShowNewMenu }}>
                    <div
                        className={`menuDiv  ${show ? 'show' : 'hide'}`}
                        onMouseEnter={toggleTheMenuShow}
                        onMouseLeave={toggleTheMenuHide}
                    >
                        <ul className="nav">
                            <SoilMenuItem
                                selected={weatherSelectedState.weatherSelected}
                                type='url'
                                title='Self-Service portal'
                                // onClick={() => console.log('first button clicked')}
                            >
                                {(color: string) => <SelfServicePortalSvgComponent
                                    color={color}
                                />}
                            </SoilMenuItem>
                            <SoilMenuItem
                                selected={weatherSelectedState.weatherSelected}
                                path={'/soilhub'}
                                title='Soil Analysis'
                                // onClick={() => console.log('second button clicked')}
                            >
                                {(color: string) => <SoilAnalysisSvgComponent color={color} />}
                            </SoilMenuItem>
                            <SoilMenuItem
                                selected={weatherSelectedState.weatherSelected}
                                path={'/weatherQuery'}
                                title='Hyper-local Weather data'
                                // onClick={() => selecteWeatherCurrentRoute(IWeatherType.WeatherStation)}
                            >
                                {(color: string) => <WeatherStationSvg color={color} />}
                            </SoilMenuItem>
                            <SoilMenuItem
                                selected={weatherSelectedState.weatherSelected}
                                path={'/agrialert/template'}
                                title='AgriAlert Portal'
                            >
                                {(color: string) => <AgriAlertSvg color={color} />}
                            </SoilMenuItem>
                        </ul>
                    </div>
                </div>

                {/* For Agrialert system sidebar setting*/}
                <div className="menu-div-hard-width" style={{ display: (currentSys === 'agrialert' ? 'block' : 'none' ) }}>
                    <ul className="nav">
                        <div
                            className={`weather-menuDiv ${show ? 'show' : 'hide'}`}
                            onMouseEnter={toggleTheMenuShow}
                            onMouseLeave={toggleTheMenuHide}
                        >
                            <SoilMenuItem
                                selected={agrialertSelectedState.templateSelected}
                                path={'/agrialert/template'}
                                title='Template'
                                onClick={()=>{
                                    dispatch(updateTemplateType(TemplateEnumType.LISTTEMPLATE));
                                }}
                            >
                                {(color: string) => <AgrialertTemplateSvg color={color} />}
                            </SoilMenuItem>
                            <IF show={isShowAgriAlertUser}>
                                <SoilMenuItem
                                    selected={agrialertSelectedState.userManagementSelected}
                                    path={'/agrialert/userManagement'}
                                    title='User Managerment'
                                >
                                    {(color: string) => <AgrialertUserManagementSvg color={color} />}
                                </SoilMenuItem>
                            </IF>
                        </div>
                    </ul>
                </div>


                {/* detail page render area */}
                <Routes>
                    {routers.map(({ path, sidebar }) => (
                        <Route key={path} path={path} element={sidebar(path)} />
                    ))}
                </Routes>
            </div>
            {/* <a className='global-help-button' onClick={()=> setUsageVisible(true)}>
                <span className='circle-queston-mark'>?</span>
                <span className='help-text-span'>
                        help
                </span>
            </a> */}
            <Loading loading={showLoading} />
        </div>
    ) : <a id='redirect' href={oauthUrl} />;
}

export default App;